<div
  class="flex flex-col gap-2 text-sm  {{
    colorClass[color] || 'text-textPrimary'
  }}"
 
>
  <label *ngIf="label" for="{{ id }}">{{ label }}</label>

  <div
    class="
    {{ colorClass[color] }}
    {{
      rounded ? 'rounded-full' : 'rounded-lg'
    }} border-2 flex items-center px-4"
     style="background-color: var(--surface-0);"
  >
    <i class="pi pi-search text-grayedOut"></i>
    <div class="ml-6 flex-1">
      <p-autoComplete
        id="{{ id }}"
        [(ngModel)]="selectedItem"
        [placeholder]="placeholder"
        [suggestions]="suggestions"
        (completeMethod)="search($event)"
        (onSelect)="onSelect($event)"
        (onUnselect)="onUnselect($event)"
        [field]="displayField"
        [multiple]="multiple"
        inputStyleClass="{{ !dense ? 'py-3' : 'py-2' }}
        w-full
        mr-6
        text-textPrimary
        text-base border-none bg-transparent outline-none focus:outline-none shadow-none"
        styleClass="w-full text-textPrimary"
      ></p-autoComplete>
    </div>
  </div>
  <small *ngIf="helperText">{{ helperText }}</small>
</div>
